import { API } from "../api/axios";
import TokenService from "./token.service";
import AuthService from "./auth.service";
import { router } from "../router/index";

const setup = (store) => {
    API.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    API.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (originalConfig.url !== "/login_admin" && err.response) {
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig.retry = true;

                    AuthService.logout();
                    router.replace({
                        name: "Login",
                    });

                    /*try {
                        const rs = await API.post("/auth/refreshtoken", {
                            refreshToken: TokenService.getLocalAccessToken(),
                        });

                        const { accessToken } = rs.data;

                        store.dispatch("auth/refreshToken", accessToken);
                        TokenService.updateLocalAccessToken(accessToken);

                        return API(originalConfig);
                    } catch (_error) {
                        return Promise.reject(err);
                    }*/
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setup;
